import Boundary from './Boundary.js';
import { c } from '../setup.js';


export default class LeftLedge extends Boundary {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
        };
    }

    static deserialize(data) {
        return new LeftLedge({ position: data.position });
    }

    constructor({ position }) {
        super({ position });
    }

    draw() {
        c.fillStyle = 'rgba(0, 0, 255, 0.0)';
        c.fillRect(
            this.position.x + this.xModifier,
            this.position.y + this.yModifier,
            this.width,
            this.height
        );
    }
}
